import { Component, input, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { CommonModule } from "@angular/common";

import {
  SessionData,
  SessionService,
} from "../../Utils/_services/session/session.service";


@Component({
  selector: "app-nav-bar",
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.css"],
})
export class NavBarComponent implements OnInit {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  showMenu = input(true);
  isMenuOpen = false;
  sessionData!: SessionData | null;

  ngOnInit(): void {
    this.sessionService.sessionData$.subscribe(data => {
      this.sessionData = data;
    });
  }

  goToAdmin() {
    this.router.navigate(["/auth/login"]);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  logout() {
    try {
      this.sessionService.clearSession();
    } catch (err) {
      console.warn("Error clearing session on logout", err);
    }
    this.router.navigate(["/auth/login"]);
  }
}
